import { POPUP_STYLE, ARROW_STYLE, MARKER_ANCHOR } from 'components/Map/NewJobMarkers/utils/markerConstants';
import { createStopPopup } from 'components/Map/NewStopMarkers/utils/stopPopupBuilder';
import { selectTourById } from 'actions';

export function attachUnselectedStopHoverEvents(marker, translationsRef, map, dispatch) {
  let popupElement = null;

  const removePopup = () => {
    if (popupElement) {
      if (popupElement._cleanup) {
        popupElement._cleanup();
      }
      popupElement.remove();
      popupElement = null;
    }
  };

  marker.addEventListener('pointerenter', () => {
    if (!popupElement) {
      const markerData = marker.getData();
      const markerPosition = marker.getGeometry();

      popupElement = document.createElement('div');
      Object.assign(popupElement.style, POPUP_STYLE);

      const content = createStopPopup(markerData, translationsRef.current);
      const arrow = document.createElement('div');
      Object.assign(arrow.style, ARROW_STYLE);

      popupElement.innerHTML = content;
      popupElement.appendChild(arrow);

      const mapContainer = map.getElement();
      mapContainer.appendChild(popupElement);

      const updatePopupPosition = () => {
        const screenPos = map.geoToScreen(markerPosition);
        popupElement.style.left = `${screenPos.x}px`;
        popupElement.style.top = `${screenPos.y - MARKER_ANCHOR.UNSELECTED.y - 4}px`;
      };

      updatePopupPosition();

      map.addEventListener('mapviewchange', updatePopupPosition);

      popupElement._cleanup = () => {
        map.removeEventListener('mapviewchange', updatePopupPosition);
      };
    }
  });

  marker.addEventListener('pointerleave', removePopup);

  marker.addEventListener('tap', (evt) => {
    evt.stopPropagation();
    const data = marker.getData();
    const routeId = data?.routeId;
    if (routeId !== undefined && routeId !== null) {
      dispatch(selectTourById({ selectedTour: routeId, noMapMovement: true }));
    }
  });

  marker._removePopup = removePopup;
}
